import { get, post, put } from './requests.js'
const ENTITY = 'destination-configuration'
export const loadSchema = async () => get([ENTITY, 'options'])
export const loadEntity = async (id) => get([ENTITY, id])
export const saveConfig = async (payload) => post([ENTITY], {}, payload)
export const updateConfig = async (id, data) => put([ENTITY, id], {}, data)
